/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_3_LinkInputs */

const en_mk_sec_3_link = /** @type {(inputs: Mk_Sec_3_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the docs`)
};

const id_mk_sec_3_link = /** @type {(inputs: Mk_Sec_3_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca dokumentasi`)
};

/**
* | output |
* | --- |
* | "Read the docs" |
*
* @param {Mk_Sec_3_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_3_link = /** @type {((inputs?: Mk_Sec_3_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_3_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_3_link(inputs)
	return en_mk_sec_3_link(inputs)
});